import React from "react"
import { navigateTo } from "gatsby-link"
import { Image, Flex, Toolbar, Heading, Box, NavLink } from "rebass"
import styled, { withComponent } from "styled-components"
import { responsiveStyle } from "styled-system"

import MaxWidth from "../MaxWidth"
import AppDrawer from "../AppDrawer"
import NavbarLink from "../NavbarLink"

import colors from "../../config/colors.js"
import logo from "../../images/yklogonew_glow.png"

const NavWrapper = styled(Toolbar)`
  background: ${props => (props.scrolled ? colors.primaryDark : "transparent")};
  height: 75px;
  position: fixed;
  top: 0;
  width: 100%
  z-index: 999;
  transition: background 0.5s ease-in-out;
`.withComponent(({ scrolled, ...rest }) => <Toolbar {...rest} />)

const display = responsiveStyle({
  prop: "display",
  cssProperty: "display",
  key: "display",
  numberToPx: false,
  getter: n => n,
  alias: "display",
})

const ResponsiveDisplay = styled(Flex)`
  ${display};
`

const HeaderImage = styled(Image)`
  height: 100%;
  width: auto;
`

//TODO: use rem instead of px. font too big on mobile
const StyledHeading = styled(Heading)`
  font-size: 24px:
  transition: font-size 0.2s ease-in-out;
`

const LogoWrapper = styled(Flex)`
  height: 60px;
  transition: height 0.2s ease-in-out;
`

LogoWrapper.defaultProps = {
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}

HeaderImage.defaultProps = { my: 0 }

const renderLink = (link, location, scrolled) => (
  <NavbarLink
    scrolled={scrolled}
    color={colors.primaryDark}
    key={link.title}
    to={link.path}
    title={link.title}
    onClick={() => {
      link.path && navigateTo(link.path)
    }}
    href={link.href || undefined}
    location={location}
  >
    {link.title}
  </NavbarLink>
)

const Header = ({
  scrolled,
  drawer,
  handleToggleDrawer,
  navLinks,
  location,
}) => (
  <div>
    <NavWrapper scrolled={scrolled}>
      <MaxWidth style={{ height: "100%" }}>
        <NavLink
          pl={0}
          onClick={() => {
            navigateTo("/")
          }}
        >
          <Flex alignItems="center">
            <LogoWrapper scrolled={scrolled}>
              <HeaderImage src={logo} />
            </LogoWrapper>
          </Flex>
        </NavLink>
        <div style={{ marginLeft: "auto" }} />
        <ResponsiveDisplay display={["flex", "flex", "none", "none"]}>
          <NavbarLink
            scrolled={scrolled}
            location={location}
            onClick={() => {
              handleToggleDrawer()
            }}
          >
            menu
          </NavbarLink>
          <AppDrawer
            handleClose={handleToggleDrawer}
            open={drawer}
            position="right"
            pt={4}
            color="white"
            bg={colors.primaryDark}
          >
            {navLinks.map(item => renderLink(item, location, true))}
          </AppDrawer>
        </ResponsiveDisplay>
        <ResponsiveDisplay display={["none", "none", "flex", "flex"]}>
          {navLinks.map(item => renderLink(item, location, scrolled))}
        </ResponsiveDisplay>
      </MaxWidth>
    </NavWrapper>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js